import {
	USER_POPULAR_GET_ERROR,
	USER_POPULAR_GET,
	USER_LOADING_STATUS,
	USER_GET,
	USER_GET_ERROR,
	USER_GET_FOLLOWERS,
	USER_GET_FOLLOWERS_ERROR,
	USER_GET_FOLLOWERS_STATUS,
	USER_GET_FOLLOWINGS_STATUS,
	USER_GET_FOLLOWINGS,
	USER_FOLLOW,
	USER_FOLLOW_STATUS,
	USER_FOLLOW_ERROR,
	USER_UNFOLLOW_STATUS,
	USER_UNFOLLOW_ERROR,
	USER_UNFOLLOW,
	USER_UNFOLLOW_FROM_LIST,
	USER_UNFOLLOW_FROM_LIST_ERROR,
	USER_UNFOLLOW_FROM_LIST_STATUS,
	USER_SHOW_SUCCESS_ALERT,
	USER_SHOW_ERROR_ALERT,
	SPEAKER_GET,
	SPEAKER_SESSIONS_GET,
	SESSION_META_GET,
	SET_SPEAKER_SESSION_LOADING_ID,
	TOGGLE_IS_SPEAKER_SESSION_LOADING,
	UPDATE_SPEAKER_SESSION
} from './types'

const initialState = {
	loading: false,
	followersLoading: false,
	followingsLoading: false,
	popularAuthors: [],
	errors: [],
	author: {},
	total: 0,
	followers: [],
	followings: [],
	followersCount: 0,
	followingsCount: 0,
	showSuccess: false,
	showError: false,
	speaker: null,
	isSpeakerSessionLoading: false,
	speakerSessionIdLoading: null
}

export const state = { ...initialState }

export default {
	[USER_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[USER_POPULAR_GET]: (state, payload) => {
		state.popularAuthors = [...payload.data]
		state.total = payload.meta['last_page']
	},

	[USER_POPULAR_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_GET]: (state, payload) => {
		state.author = payload
	},

	[SPEAKER_GET]: (state, speaker) => {
		if (!state.speaker) {
			state.speaker = speaker
		} else {
			state.speaker = { ...state.speaker, ...speaker }
		}
	},

	[SPEAKER_SESSIONS_GET]: (state, sessions) => {
		if (!state.speaker) {
			state.speaker = {sessions}
		} else if (state.speaker && !state.speaker.sessions) {
			state.speaker.sessions = sessions
		} else {
			state.speaker.sessions = { ...state.speaker.sessions, ...sessions}
		}
	},

	[SESSION_META_GET]: (state, payload) => {
		const {
			pageCount,
			perPage,
			totalCount,
			currentPage,
			type
		} = payload

		const meta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}

		state.speaker = {
			...state.speaker, 
			metaList: state.speaker.metaList ? { ...state.speaker.metaList, [type]: meta } : {[type] : meta}
		}
	},

	[USER_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_FOLLOW]: (state, payload) => {
		state.followers = [...state.followers, payload]
	},

	[USER_FOLLOW_STATUS]: (state, status) => {
		state.loading = status
	},

	[USER_FOLLOW_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_UNFOLLOW_FROM_LIST_STATUS]: (state, status) => {
		state.loading = status
	},

	[USER_UNFOLLOW_FROM_LIST]: (state, payload) => {
		state.followings = state.followings.filter((item) => item.id !== payload.id)
	},

	[USER_UNFOLLOW_FROM_LIST_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_UNFOLLOW]: (state, payload) => {
		state.followers = state.followers.filter((item) => item.id !== payload.id)
	},

	[USER_UNFOLLOW_STATUS]: (state, status) => {
		state.loading = status
	},

	[USER_UNFOLLOW_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_GET_FOLLOWERS_STATUS]: (state, payload) => {
		state.followersLoading = payload
	},

	[USER_GET_FOLLOWERS]: (state, payload) => {
		state.followers = payload.data
		state.followersCount = payload.meta.total
	},

	[USER_GET_FOLLOWERS_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_GET_FOLLOWINGS_STATUS]: (state, payload) => {
		state.followingsLoading = payload
	},

	[USER_GET_FOLLOWINGS]: (state, payload) => {
		state.followings = payload.data
		state.followingsCount = payload.meta.total
	},

	[USER_GET_FOLLOWERS_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[USER_SHOW_SUCCESS_ALERT]: (state) => {
		state.showSuccess = true
	},
	[USER_SHOW_ERROR_ALERT]: (state) => {
		state.showError = true
	},
	[TOGGLE_IS_SPEAKER_SESSION_LOADING]: (state, status) => {
		state.isSpeakerSessionLoading = status
	},
	[SET_SPEAKER_SESSION_LOADING_ID]: (state, id) => {
		state.speakerSessionIdLoading = id
	},
	[UPDATE_SPEAKER_SESSION]: (state, {id, type, status}) => {
		state.speaker.sessions[type] = state.speaker.sessions[type].map(item => {
			if (id === item.events_agenda_id) {
				return {
					...item,
					is_scheduled: status
				}
			} else {
				return item
			}
		})
	}
}
